import React, {useEffect, useState} from "react";
import ImageEditDialog from "@configuratorware/configurator-frontendgui/App/Modules/Designer/Containers/ImageEditDialog";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import {
    TextField,
    makeStyles, Typography,
} from "@material-ui/core";
import { saveNote } from "../../Reducers/ImageGallery/Actions";

export const useStyles = makeStyles(
  (theme) => ({
    controlElementSection: {
      display: "flex",
      justifyContent: "flex-end",
    },
    notefield: {
      width: "100%",
      marginBottom: 14
    },
    noteTitle: {
      width: "100%",
    },
  }),
  { name: "CustomImageEditContainer" }
);

const CustomImageEditDialogContainer = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const imageNote = useSelector((state) =>
    get(state, "imageGallery.selectedImage.note", "")
  );

  const [note, setNote] = useState("");

  useEffect(() => {
    setNote(imageNote);
  }, [imageNote]);

  return (
    <ImageEditDialog
      {...props}
      checkOwnership={false}
      customControlElements={
        <div>
            <Typography className={classes.noteTitle}>{t("noteDialog.title")}</Typography>
            <TextField
                className={classes.notefield}
                value={note}
                multiline={true}
                rows={2}
                rowsMax={3}
                variant="outlined"
                onChange={(e) => setNote(e.target.value)}
                onBlur={(e) => dispatch(saveNote(note))}
            />
        </div>
      }
    />
  );
};
export default CustomImageEditDialogContainer;

